import { Endpoint } from '@/types/api.type.ts';

export const carEndpoints: Endpoint[] = [
    {
        name: 'GetCars',
        method: 'get',
        path: '/cars',
    },
    {
        name: 'GetCar',
        method: 'get',
        path: '/cars/:id',
    },
    {
        name: 'CreateCar',
        method: 'post',
        path: '/cars',
    },
    {
        name: 'UpdateCar',
        method: 'post',
        path: '/cars/:id',
    },
    {
        name: 'DeleteCar',
        method: 'delete',
        path: '/cars/:id',
    },
    {
        name: 'SendCarToModeration',
        method: 'post',
        path: '/cars/send-to-moderation/:id',
    },
    {
        name: 'ApproveCar',
        method: 'post',
        path: '/cars/approve/:id',
    },
    {
        name: 'RejectCar',
        method: 'post',
        path: '/cars/reject/:id',
    },
    {
        name: 'RecreateCar',
        method: 'post',
        path: '/cars/recreate/:id',
    },
    {
        name: 'DecodeVin',
        method: 'get',
        path: '/cars/decode-vin/:vin',
    },
    {
        name: 'GetCarDocumentData',
        method: 'get',
        path: '/cars/documents/:id',
    },
];
